import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";
import AppDataGrid from "../../components/common/AppDataGrid";
import Tooltip from "@mui/material/Tooltip";
import excelIcon from "../../assets/icons/excel.png";

const Employeelatedays = () => {
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [attendanceDate, setAttendanceDate] = useState([]);
  const [form, setForm] = useState({
    
    start_date:"",
    end_date:""
  });

  const [employeesData, setEmployeesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const searchableColumns = ["employee_name", "late_days_count"];

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

//   const getSelectedMonthName = () => {
//     const match = monthList.find(
//       (m) => String(m.month_id) === String(form.month_id)
//     );
//     return match?.month_name || "";
//   };

 const fetchData = async () => {
  if (!form.start_date || !form.end_date) {
    toast.error("Please select start and end date");
    return;
  }

  setIsLoading(true);
  try {
    const response = await axios.get(
      `${baseUrl}/employee-late-days/`,
      {
        params: {
          school_id: userObj.school_id,
          from_date: form.start_date,
          to_date: form.end_date,
        },
      }
    );

    const data = Array.isArray(response.data) ? response.data : [];

    const mapped = data.map((row, index) => ({
      id: index + 1,
      userid: row.userid,
      employee_name: row.employee_name,
      late_days_count: row.late_days_count,
    }));

    setEmployeesData(mapped);
  } catch (error) {
    console.error(error);
    // toast.error("Failed to fetch late days data");
    setEmployeesData([]);
  } finally {
    setIsLoading(false);
  }
};

//   const fetchMonths = async () => {
//     try {
//       const response = await axios.post(baseUrl + "/months/", {
//         action: "READ",
//       });
//       const list = Array.isArray(response.data) ? response.data : [];
//       setMonthList(list);

//       const currentMonthNumber = new Date().getMonth() + 1;
//       const currentMonthObj =
//         list.find((m) => Number(m.month_id) === currentMonthNumber) || list[0];

//       if (currentMonthObj) {
//         const idStr = String(currentMonthObj.month_id);
//         setForm((prev) => ({
//           ...prev,
//           month_id: idStr,
//         }));
//         fetchData(idStr);
//       }
//     } catch (error) {
//       console.error("Failed to load months:", error);
//       toast.error("Failed to load months.");
//     }
//   };

//   useEffect(() => {
//     fetchMonths();
//   }, []);

 const handleSubmit = (e) => {
  e.preventDefault();
  fetchData();
};


 const exportToExcel = () => {
  if (!employeesData.length) {
    toast.error("No data available to export.");
    return;
  }

  const exportData = employeesData.map((row) => ({
    "Emp Name": row.employee_name || "-",
    "Total Late Days": row.late_days_count ?? "-",
  }));

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Employee Late Days");

  XLSX.writeFile(
    wb,
    `employee_late_days_${form.start_date}_to_${form.end_date}.xlsx`
  );
};


  const exportToPDF = () => {
  if (!employeesData.length) {
    toast.error("No data available to export.");
    return;
  }

  const doc = new jsPDF();
  doc.text(
    `Employee Late Days Report (${form.start_date} to ${form.end_date})`,
    14,
    12
  );

  const tableColumn = ["Emp Name", "Total Late Days"];

  const tableRows = employeesData.map((row) => [
    row.employee_name || "-",
    row.late_days_count ?? "-",
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 20,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [0, 123, 255] },
  });

  doc.save(
    `employee_late_days_${form.start_date}_to_${form.end_date}.pdf`
  );
};


  const normalizedQuery = (searchQuery || "").toLowerCase().trim();
  const filteredEmployees = employeesData.filter((row) =>
    searchableColumns.some((col) =>
      (row[col] || "")
        .toString()
        .toLowerCase()
        .includes(normalizedQuery)
    )
  );

  const columns = [
    // {
    //   field: "emp_code",
    //   headerName: "Emp Id",
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: true,
    //   renderCell: (params) => (
    //     <Tooltip title={params.value || ""}>
    //       <span>{params.value || ""}</span>
    //     </Tooltip>
    //   ),
    // },
    {
      field: "employee_name",
      headerName: "Emp Name",
      flex: 1.5,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span>{params.value || ""}</span>
        </Tooltip>
      ),
    },
    {
      field: "late_days_count",
      headerName: "Total Late Days",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value?.toString() || ""}>
          <span>{params.value ?? ""}</span>
        </Tooltip>
      ),
    },
    // {
    //   field: "present_days",
    //   headerName: "Present Days",
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: true,
    //   renderCell: (params) => (
    //     <Tooltip title={params.value?.toString() || ""}>
    //       <span>{params.value ?? ""}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   field: "absent_days",
    //   headerName: "Absent Days",
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: true,
    //   renderCell: (params) => (
    //     <Tooltip title={params.value?.toString() || ""}>
    //       <span>{params.value ?? ""}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   field: "leaves",
    //   headerName: "Leaves",
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: true,
    //   renderCell: (params) => (
    //     <Tooltip title={params.value?.toString() || ""}>
    //       <span>{params.value ?? ""}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   field: "payable_days",
    //   headerName: "Payable Days",
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: true,
    //   renderCell: (params) => (
    //     <Tooltip title={params.value?.toString() || ""}>
    //       <span>{params.value ?? ""}</span>
    //     </Tooltip>
    //   ),
    // },
  ];

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">
                    Employee Late Days Report
                  </h6>
                </Col>
              </Row>

              <Row className="align-items-end">
                <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                            
                          <Form.Label>Start Date<span className="requiredStar">*</span></Form.Label>
                          <Form.Control
  type="date"
  id="start_date"
  value={form.start_date}
  onChange={handleInputChange}
  required
/>

                        </Form.Group>
                      </div>
                    </Col>
                     <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>End Date <span className="requiredStar">*</span></Form.Label>
                         <Form.Control
  type="date"
  id="end_date"
  value={form.end_date}
  onChange={handleInputChange}
  required
/>

                        </Form.Group>
                      </div>
                    </Col>

                    
                    
                <Col>
                                    <div className="d-flex justify-content-end mt-4"> {/* Reduced margin from mt-5 to mt-4 */}
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-info clearBtn me-3"
                                            onClick={() => {
                                                setForm({
                                                    start_date: "",
                                                    end_date: "",
                                                });
                                                setEmployeesData([]); 
                                                 setSearchQuery("");
                                                // setFromDate(null);
                                                // setToDate(null);
                                                // setSearchQuery('');
                                                // setStudentsData([]);
                                            }}
                                        >
                                            Reset
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="btn-success primaryBtn"
                                        >
                                            Search
                                        </Button>
                                    </div>
                                </Col>
              </Row>
            </form>
          </Card.Body>
        </Card>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            className="form-control form-control-sm w-25"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div>
            <Button
              className="btnMain"
              variant="success"
              onClick={exportToExcel}
              style={{ marginRight: "10px" }}
            >
              <img
                src={excelIcon}
                alt="Download Excel"
                style={{ width: "20px" }}
              />
            </Button>
            <Button className="btnMain" variant="danger" onClick={exportToPDF}>
              <FaFilePdf style={{ marginRight: "5px" }} />
            </Button>
          </div>
        </div>

        <div className="commonTable height100 mt-2">
          <div className="tableBody">
            <div style={{ width: "100%", overflowX: "auto" }}>
              <AppDataGrid
                rows={filteredEmployees.length ? filteredEmployees : []}
                columns={columns}
               getRowId={(row) => row.userid}

                pageSizeOptions={[10, 20, 50]}
                showToolbar={false}
                pagination
                density="compact"
                maxHeight={400}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Employeelatedays;
